import { format, unwrapFunctionStore } from 'svelte-i18n';

import { studioSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

let escapeListener = null;

const $format = unwrapFunctionStore(format);

export const usingTemplate = {
  element: 'div.carousel > div > div > div > div',
  popover: {
    title: $format('label.TOURS.STUDIO.CREATE.USING_TEMPLATE.TITLE'),
    description: $format('label.TOURS.STUDIO.CREATE.USING_TEMPLATE.DESCRIPTION'),
    side: 'right',
    align: 'center',
    onPopoverRender: () => {
      const closeButton = document.querySelector('.close');

      escapeListener = (event) => {
        if (event.key === 'Escape') {
          if (closeButton) {
            closeButton.click();
          }
          document.removeEventListener('keydown', escapeListener);
        }
      };

      document.addEventListener('keydown', escapeListener);
    },
    onPrevClick: () => {
      const backButton = document.querySelector('.back');

      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      if (backButton) {
        backButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 200);
      }
    },
    onNextClick: () => {
      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      GLOBAL_DRIVER_OBJECT.moveNext();
    }
  }
};

export const carouselNavigation = {
  element: '.modal-content',
  popover: {
    description: $format('label.TOURS.STUDIO.CREATE.USING_TEMPLATE.CAROUSEL_NAV.DESCRIPTION'),
    side: 'bottom',
    align: 'center',
    onPopoverRender: () => {
      const leftArrow = document.querySelector('div.carousel > div > i.os-icon-arrow-left');
      const rightArrow = document.querySelector('div.carousel > div > i.os-icon-arrow-right');
      const closeButton = document.querySelector('.close');

      escapeListener = (event) => {
        if (event.key === 'Escape') {
          if (closeButton) {
            closeButton.click();
          }
          document.removeEventListener('keydown', escapeListener);
        }
      };

      document.addEventListener('keydown', escapeListener);

      if (rightArrow && leftArrow) {
        setTimeout(() => {
          rightArrow.click();
        }, 1500);

        setTimeout(() => {
          leftArrow.click();
        }, 3000);
      }
    },
    onPrevClick: () => {
      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      GLOBAL_DRIVER_OBJECT.movePrevious();
    },
    onNextClick: () => {
      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      GLOBAL_DRIVER_OBJECT.moveNext();
    }
  }
};

export const clickUseTemplate = {
  element: '#modal-btn',
  popover: {
    description: $format('label.TOURS.STUDIO.CREATE.USING_TEMPLATE.TEMPLATE_BUTTON.DESCRIPTION'),
    side: 'bottom',
    align: 'center',
    onPopoverRender: () => {
      const closeButton = document.querySelector('.close');

      escapeListener = (event) => {
        if (event.key === 'Escape') {
          if (closeButton) {
            closeButton.click();
          }
          document.removeEventListener('keydown', escapeListener);
        }
      };

      document.addEventListener('keydown', escapeListener);
    },
    onPrevClick: () => {
      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      GLOBAL_DRIVER_OBJECT.movePrevious();
    },
    onNextClick: () => {
      const closeButton = document.querySelector('.close');

      if (escapeListener) {
        document.removeEventListener('keydown', escapeListener);
      }

      studioSettingsStore.subscribe((studio) => {
        studio.tours.createHasToured = true;
      })();

      if (closeButton) {
        closeButton.click();

        GLOBAL_DRIVER_OBJECT.destroy();
      }
    }
  }
};
